import { Controller } from "stimulus";

var delayTimer;

export default class extends Controller {
    static targets = [
        "searchField", "searchResults", "profileId",
        "firstName", "lastName", "email", "phone",
        "profileFields", "selectedBadge", "selectedName"
    ];

    connect() {
        this.updateFieldState();
    }

    requestSearch() {
        clearTimeout(delayTimer);
        const query = this.searchFieldTarget.value.trim();
        const resultsArea = this.searchResultsTarget;

        if (query.length < 2) {
            resultsArea.classList.add("hidden");
            resultsArea.innerHTML = "";
            return;
        }

        delayTimer = setTimeout(() => {
            this.performSearch(query, resultsArea);
        }, 300);
    }

    performSearch(query, resultsArea) {
        const endpoint = `/hr/profiles/search.json?q=${encodeURIComponent(query)}`;

        fetch(endpoint)
            .then((response) => response.json())
            .then((results) => {
                resultsArea.innerHTML = this.buildResults(results);
                resultsArea.classList.remove("hidden");
            })
            .catch((error) => {
                console.error("Profile search error:", error);
            });
    }

    buildResults(results) {
        if (!results || results.length === 0) {
            return '<div class="px-4 py-2 text-sm text-gray-500">No profiles found. Fill in the fields below to create a new one.</div>';
        }

        return results.map((profile) =>
            `<div class="px-4 py-2 hover:bg-purple-50 cursor-pointer text-sm"
                  data-action="click->hr-profile-search#selectProfile"
                  data-profile-id="${profile.id}"
                  data-first-name="${this.escapeAttr(profile.first_name)}"
                  data-last-name="${this.escapeAttr(profile.last_name)}"
                  data-email="${this.escapeAttr(profile.email)}"
                  data-phone="${this.escapeAttr(profile.phone || '')}">
                <span class="font-medium text-gray-900">${this.escapeHtml(profile.first_name)} ${this.escapeHtml(profile.last_name)}</span>
                <span class="text-gray-500 ml-1">${this.escapeHtml(profile.email)}</span>
            </div>`
        ).join("");
    }

    selectProfile(event) {
        const el = event.currentTarget;
        const profileId = el.dataset.profileId;
        const firstName = el.dataset.firstName;
        const lastName = el.dataset.lastName;
        const email = el.dataset.email;
        const phone = el.dataset.phone;

        this.profileIdTarget.value = profileId;
        this.firstNameTarget.value = firstName;
        this.lastNameTarget.value = lastName;
        this.emailTarget.value = email;
        this.phoneTarget.value = phone;

        this.searchFieldTarget.value = "";
        this.searchResultsTarget.classList.add("hidden");
        this.searchResultsTarget.innerHTML = "";

        this.updateFieldState();
    }

    clearProfile() {
        this.profileIdTarget.value = "";
        this.firstNameTarget.value = "";
        this.lastNameTarget.value = "";
        this.emailTarget.value = "";
        this.phoneTarget.value = "";

        this.updateFieldState();
        this.searchFieldTarget.focus();
    }

    updateFieldState() {
        const hasProfile = this.profileIdTarget.value !== "";

        if (this.hasSelectedBadgeTarget) {
            if (hasProfile) {
                const name = this.firstNameTarget.value + " " + this.lastNameTarget.value;
                this.selectedNameTarget.textContent = name;
                this.selectedBadgeTarget.classList.remove("hidden");
                this.searchFieldTarget.parentElement.classList.add("hidden");
            } else {
                this.selectedBadgeTarget.classList.add("hidden");
                this.searchFieldTarget.parentElement.classList.remove("hidden");
            }
        }

        if (this.hasProfileFieldsTarget) {
            const fields = this.profileFieldsTarget.querySelectorAll("input");
            fields.forEach((field) => {
                field.readOnly = hasProfile;
                if (hasProfile) {
                    field.classList.add("bg-gray-50", "text-gray-500");
                } else {
                    field.classList.remove("bg-gray-50", "text-gray-500");
                }
            });
        }
    }

    escapeHtml(text) {
        const div = document.createElement("div");
        div.textContent = text;
        return div.innerHTML;
    }

    escapeAttr(text) {
        return text.replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    }
}
